module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "grid"
    }
  }, [_c('canvas', {
    directives: [{
      name: "insert-in-canvas",
      rawName: "v-insert-in-canvas",
      value: ({
        cells: _vm.cells,
        color: 'white'
      }),
      expression: "{ cells: cells, color: 'white' }"
    }],
    staticStyle: {
      "border": "1px solid #BBB"
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44ceb462!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/Grid.vue
// module id = 24
// module chunks = 1